import { findFragranceForLog, wearLabelText } from '../../lib/homeNav'
import { sessionStartedAt } from '../../lib/wearSessions'
import FragranceImage from '../collection/FragranceImage'

export default function DailyWearHistory({ logs = [], fragrances = [], onOpen, onOpenWear = onOpen, onOpenFragrance = onOpen }) {
  if (!logs.length) return null
  return <section aria-label="Also wearing" className="space-y-2">
    <div>
      <h2 className="text-sm font-semibold text-cream">Also wearing</h2>
    </div>
    {logs.map(log => {
      const fragrance = findFragranceForLog(log, fragrances)
      return <article key={log.id} data-daily-wear={log.id} className="flex items-center gap-3 rounded-xl border border-white/10 bg-charcoal-800 p-2">
        <button type="button" disabled={!fragrance} onClick={() => fragrance && onOpenFragrance?.(fragrance)} aria-label={`Open ${fragrance?.name || log.fragrance_name || 'recorded fragrance'} details`} className="flex min-w-0 flex-1 items-center gap-3 text-left disabled:cursor-default">
          <div className="w-10 shrink-0"><FragranceImage fragrance={fragrance || {}} /></div><div className="min-w-0 flex-1">
          <h3 className="font-semibold text-cream">{fragrance?.name || log.fragrance_name || 'Recorded fragrance'}</h3>
          <p className="mt-1 text-xs text-cream/60">{fragrance?.house || log.house} · {wearLabelText(log)} · {new Date(sessionStartedAt(log)).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}</p>
          {(log.layered_with || []).length > 0 && <p className="mt-2 text-sm text-gold">Layered with {log.layered_with.join(' + ')}</p>}
          </div>
        </button>
        <button type="button" aria-label={`Open saved wear for ${fragrance?.name || 'recorded fragrance'}`} onClick={() => onOpenWear?.(log)} className="min-h-11 shrink-0 rounded-lg px-2 text-xs font-semibold text-gold">Wear details</button>
      </article>
    })}
  </section>
}
